<template>
  <div class="list-view">
    <list-head :mode="mode" v-on:modeChange="modeChange(arguments[0])" ref="header" @getUserInfo="getUserInfo"></list-head>
    <router-view v-on:refreshUsage="refreshUsage"></router-view>
    <list-foot ref="footer" @goFeedback="goFeedback"></list-foot>
    <feedback v-if="showFeedback" :feedbackSuccess="feedbackSuccess" @submitFeedback="submitFeedback" @closeFeedbackPop="closeFeedbackPop"></feedback>
  </div>
</template>

<script>
import ListHead from './ListHead.vue'
import ListFoot from '../ListFoot.vue'
import Feedback from '../Feedback'
import HttpClient from 'common/script/http'
import * as Config from 'common/script/config'
export default {
  name: 'listView',
  components: {
    ListHead,
    ListFoot,
    Feedback
  },
  // 监测路由
  beforeRouteUpdate (to, from, next) {
    if (to.path === '/notebook/notebook' || to.path === '/notebook' || to.path === '/notebook/notebook/notes') {
      this.mode = 3
    } else if (to.path === '/notebook/tag' || to.path === '/notebook/tag/tagDetail') {
      this.mode = 4
    } else if (to.path === '/notebook/pdf') {
      this.header.openPdfMode()
      this.mode = 5
    }
    next()
  },
  mounted () {
    this.toggleBodyClass('addClass', 'list')
  },
  destroyed () {
    this.toggleBodyClass('removeClass', 'list')
  },
  data () {
    return {
      src: '',
      userName: '',
      mode: 3,
      showDMP: false,
      showFeedback: false,
      nickname: '',
      email: '',
      feedbackSuccess: false
    }
  },
  computed: {
    header () {
      return this.$refs.header
    },
    footer () {
      return this.$refs.footer
    }
  },
  created () {
    if (Config.getReqParam('action') === 'logout') {
      window.location.href = Config.urlRemoveParam(['action'])
    }
    if (this.$route.path === '/notebook/notebook' || this.$route.path === '/notebook' || this.$route.path === '/notebook/notebook/notes') {
      this.mode = 3
    } else if (this.$route.path === '/notebook/tag' || this.$route.path === '/notebook/tag/tagDetail') {
      this.mode = 4
    } else if (this.$route.path === '/notebook/pdf') {
      this.mode = 5
    }
  },
  methods: {
    toggleBodyClass: function (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    getUserInfo: function (val1, val2) {
      this.nickname = val1
      this.email = val2
    },
    submitFeedback: function (val) {
      HttpClient.postData(Config.INTERNAL_HOST + '/czur_scanner/v1/uploadFailureFiles.do', {
        lang: 'zh',
        domestic: 1,
        os: navigator.platform,
        firstName: this.nickname,
        email: this.email,
        type: 1,
        productName: 'CZUR_WEB_ET',
        content: val
      }, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          this.feedbackSuccess = true
        }
      })
    },
    closeFeedbackPop: function () {
      this.showFeedback = false
      this.feedbackSuccess = false
    },
    goFeedback: function () {
      this.showFeedback = true
    },
    modeChange: function (val) {
      this.mode = val
      if (this.mode === 3) {
        this.$router.push('/notebook/notebook')
      } else if (this.mode === 4) {
        this.$router.push('/notebook/tag')
      } else if (this.mode === 5) {
        this.$router.push('/notebook/pdf')
      }
    },
    refreshUsage: function () {
      this.footer.refreshUsage()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
body,html
  &.list
    height auto
    overflow-y auto
    background-color #f5f5f5
  &.player-show
    height 100%
    overflow hidden
  .list-view
    width 100%
    height 100%
    overflow auto
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ListView.vue